<template>
  <div class="input-wrapper">
    <vuejs-datepicker
      :language="language.es"
      input-class="form-input"
      :class="{ 'vdp-datepicker--error': error }"
      :placeholder="placeholder"
      format="dd/MM/yyyy"
      @input="updateValue"
      :value="value"
      :use-utc="true"
    >
      <span slot="afterDateInput" class="icon-datepicker">
        <img src="@/assets/icons/ic-calendar.svg" />
      </span>
    </vuejs-datepicker>
    <label
      class="form-label-internal"
      v-if="label"
      :class="{ 'form-label-internal--error': error }"
      >{{ label }}</label
    >
    <div class="form-text-validation form-text-validation--error" v-if="error">
      <span class="text-validation">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import vuejsDatepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/dist/locale';
import { formatDate } from '@/utils/format';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '19/03/1982',
    },
    value: {},
    errorMessage: {
      type: String,
      default: null,
    },
    error: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    vuejsDatepicker,
  },
  data() {
    return {
      language: { es },
    };
  },
  methods: {
    updateValue(value) {
      let date = formatDate(value);

      this.$emit('input', date);
    },
  },
};
</script>

<style></style>
